import axios from 'axios'
import store from '@/store'
import router from '@/router'

// 创建 axios 实例
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://www.airpets.cn',
  timeout: 10000,
  // headers: {
  //   'Content-Type': 'application/json;charset=UTF-8'
  // }
})
// multipart/form-data
// 请求拦截器
api.interceptors.request.use(
  config => {
    // const token = store.state.token
    const token = localStorage.getItem('token')
    // const token = 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIxMTIwOTMwMDc2MTczOTYzMjY0ZTEwYWRjMzk0OWJhNTlhYmJlNTZlMDU3ZjIwZjg4M2UifQ.2cgsuFHQxgORQqUEwPt-lJ2RZ36EgLZN1r37vmPwE_M'
    if (token) {
      config.headers['token'] = `${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    if (response.data.status == 10101) {
      localStorage.clear()
      sessionStorage.clear()
      // router.push('/login')
      return
    }
    return response.data
  },
  error => {
    if (!sessionStorage.getItem('info')) {
      localStorage.clear()
      sessionStorage.clear()
      router.push('/login')
      return
    }
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，清除用户信息并跳转到登录页面
          store.dispatch('logout')
          router.push('/login')
          break
        case 403:
          // 权限不足
          console.error('权限不足')
          break
        case 404:
          // 请求的资源不存在
          console.error('请求的资源不存在')
          break
        case 500:
          // 服务器错误
          console.error('服务器错误')
          break
        case 417:
          // 服务器错误
          console.error(error.response.data.message)
          break
        default:
          console.error(`未知错误: ${error.response.status}`)
      }
    } else {
      // 网络错误
      console.error('网络错误，请检查您的网络连接')
    }
    return Promise.reject(error)
  }
)

export default api 